// ===================== 通用 =====================

export interface Response<T> {
  code: number;
  message: string;
  data: T;
}

// ===================== 用户/登录 =====================

export interface UserLoginRequest {
  address: string;
  signature: string;
  message: string;
  clientId: string;
  clientName: string;
  clientSystem: string;
  parentInviteCode: string;
}

export interface LoginResponse {
  uid: string;
  token: string;
  data: {
    result: number; // 0-成功 1-签名错误 2/3-需要邀请码
  };
}

export interface GetLpInfoResponse {
  token0PoolBalance: string;
  token0Decimal: number;
  token0Contract: string;
  token1PoolBalance: string;
  token1Decimal: number;
  token1Contract: string;
}
// type GetPlatFormConfigResponse struct {
//  InnerTransferSwitch bool   json: "innerTransferSwitch" //内部转账通道开关
//  InnerTransferMin    string json: "innerTransferMin"    //内部转账金额最小限制 小于0时不限制
//  InnerTransferMax    string json: "innerTransferMax"    //内部转账金额最大限制 小于0时不限制
//  BnbFee              string json: "bnbFee"              //与合约交付 每次收取BNB费
//  AllowWithdrawSwitch bool   json: "allowWithdrawSwitch" //允许提现开关
//  BuyTokenSwitch      bool   json: "buyTokenSwitch"      //购买token 开关
//  DepositRecipient    string json: "depositRecipient"    //充值收款地址
// }
export interface PlatFormResponse {
  /** 内部转账通道开关 */
  innerTransferSwitch: boolean;
  /** 内部转账金额最小限制；小于 0 时不限制 */
  innerTransferMin: string;
  /** 内部转账金额最大限制；小于 0 时不限制 */
  innerTransferMax: string;
  placeOrderSwitch: boolean; //下单开关
  /** 与合约交付每次收取的 BNB 费 */
  bnbFee: string;
  /** 允许提现开关 */
  allowWithdrawSwitch: boolean;
  /** 购买 token 开关 */
  buyTokenSwitch: boolean;
  /** 充值收款地址 */
  depositRecipient: string;

  /** 订单静态收益比例（千分比） */
  orderStaticRatio: number;
  /** 订单静态纯 U 比例（千分比） */
  orderStaticOnlyURatio: number;
  /** 订单静态 U 转 TSK 比例（千分比） */
  orderStaticU2TskRatio: number;
  /** 订单动态收益比例（千分比） */
  orderDynamicRatio: number;
  /** 订单动态纯 U 比例（千分比） */
  orderDynamicOnlyURatio: number;
  /** 订单动态 U 转 TSK 比例（千分比） */
  orderDynamicU2TskRatio: number;
  /** 订单国库 U 转 TSK 比例（千分比） */
  orderTreasuryTskURatio: number;
  /** 订单平台获得 U 比例（千分比） */
  orderPlatURatio: number;
  /** 订单亏损后获得 TSKx 积分比例（千分比） */
  orderCloseLossTskxRatio: number;
  /** 开仓订单最大单数 */
  openOrderMaxCount: number;
  withdrawUsdtFeeRatio: number; //提现手续费
}

export interface UserInfoResponse {
  address: string;
  inviteCode: string;
  parent: string;
  platCode: number;
  uid: string;
  canMix: boolean; //是否支持混合支付 老用户专享;
}

/** 与后端 `GetDepositRecipientRequest` 对齐，请求体为空对象 */
export interface GetDepositRecipientRequest {}

/** 与后端 `GetDepositRecipientResponse` 对齐 */
export interface GetDepositRecipientResponse {
  /** 充值收款地址 */
  depositRecipient: string;
}

/** 资金托管全局配置（/game/user/GetCustodyConfig） */
export interface GetCustodyConfigResponse {
  /** 当月全局托管入金上限（wei） */
  monthlyQuotaUsdtWei: string;
  /** 单笔最小托管（wei） */
  minOrderUsdtWei: string;
  /** 单用户入金托管上限（wei） */
  maxPerUserUsdtWei: string;
  /** 基础日收益率基点（100=1%/日） */
  baseDailyYieldBps: number;
  /** 领取静态手续费基点（1000=10%） */
  claimFeeBps: number;
  /** 一键复投最低待领静态 U（wei） */
  reinvestMinPendingStaticWei: string;
  /** 当月已占用托管本金（wei） */
  usedMonthlyPrincipalUsdtWei: string;
}

/** 获取进行中托管主单列表请求（/game/user/GetCustodyOrders，仅 type=1） */
export interface GetCustodyOrdersRequest {
  /** 固定为 `1`：进行中托管主单 */
  type: 1;
}

/** 托管主单条目（`GetCustodyOrdersResponse.orders[]`） */
export interface CustodyOrderItem {
  /** 主单 ID */
  mergedOrderId: string;
  /** UTC 合并日（整数 yyyymmdd） */
  utcMergeYmd: number;
  /** 1=托管中；2=关闭 */
  status: 1 | 2;
  /** 当前在池本金（wei） */
  principalUsdtWei: string;
  /** 累计进入本金（入金 + 复投，wei） */
  totalEnteredCustodyPrincipalUsdtWei: string;
  /** 待领静态 U（wei） */
  pendingStaticUsdtWei: string;
  /** 待领 TSK 折算 U 价值（wei） */
  pendingExchangeTskValueUsdtWei: string;
  /** 已领静态 U 累计（含领到余额净额 + 复投全额，wei） */
  claimedStaticUsdtWei: string;
  /** 已领 TSK 价值侧 U（wei） */
  claimedExchangeTskValueUsdtWei: string;
  /** 已领 TSK 代币（wei） */
  claimedTskWei: string;
  /** 复投累计 U（wei） */
  reinvestedUsdtWei: string;
  /** 首次入金时间（毫秒时间戳） */
  firstDepositAt: number;
  /** 冷静期结束时间（毫秒时间戳） */
  coolingEndsAt: number;
  /** 开始交易时间（毫秒时间戳） */
  tradeStartsAt: number;
  /** 首次可领静态收益时间（毫秒时间戳） */
  firstStaticClaimableAt: number;
  /** 锁定期截止时间（毫秒时间戳） */
  lockUntilMs: number;
  /** 累计退出罚金（wei） */
  exitPenaltyUsdtWei: string;
  /** 累计退出托管本金合计（wei，对应 `ExitTotalPrincipalUsdt`） */
  totalExitPenaltyUsdtWei: string;
  /** 累计已退回净本金（wei） */
  returnedPrincipalUsdtWei: string;
  /** 当前锁定待退回净本金（wei） */
  lockedPrincipalUsdtWei: string;
  /** 仅 `GetCustodyOrders` type=1：今日静态 U 入账（UTC0 日息流水，wei） */
  todayEarningsUsdtWei?: string;
  /** 仅 `GetCustodyOrders` type=1：今日 TSK 价值侧 U 入账（wei） */
  todayEarningsTskValueUsdtWei?: string;
  /** 智能体托管交易资金加速（万分比；0 表示无加速） */
  aiManageAddSpeedBp?: number;
}

export interface GetCustodyOrdersResponse {
  orders: CustodyOrderItem[];
}

/** 获取托管解除记录请求（/game/user/GetCustodyExitRecords，退出子明细分页） */
export interface GetCustodyExitRecordsRequest {
  /** 页码，从 1 起，默认 1 */
  page?: number;
  /** 每页条数，默认 20，最大 100 */
  pageSize?: number;
  /** 非空时仅查该合并主单下的解除记录 */
  mergedOrderId?: string;
}

/**
 * 单条托管解除记录（`GetCustodyExitRecords` 的 `records[]` 元素，一条 `custodyMergedExitLine`）
 */
export interface CustodyExitRecordItem {
  /** 退出子记录主键 */
  id: string;
  /** 合并托管主单 ID */
  mergedOrderId: string;
  /** 托管开始时间（毫秒）：主单 `FirstDepositAt` */
  firstDepositAt: number;
  /** 退出时间（毫秒）：退出子记录 `ExitedAt` */
  exitedAt: number;
  /** 退出本金（wei）：退出子记录 `ExitedPrincipalUsdt` */
  exitedPrincipalUsdtWei: string;
  /** 惩罚金（wei）：退出子记录 `PenaltyUsdt` */
  penaltyUsdtWei: string;
  /** 扣罚后待解锁净额（wei）：退出子记录 `NetLockedUsdt` */
  netLockedUsdtWei: string;
  /** 锁定到期（毫秒） */
  lockUntilMs: number;
  /** 已退回时间（毫秒）；`0` 表示未退回 */
  returnedAt: number;
  /**
   * 解除时托管加速万分比快照（退出子记录，非当前用户实时值）
   * 用于展示该笔解除订单当时的智能体加速月化
   */
  aiManageAddSpeedBp: number;
  /**
   * 纯 U 静态收益（wei）：
   * 退出时间早于该主单首次领取则为 0，否则为待领+已领 USDT
   */
  onlyUsdtWei: string;
  /**
   * TSK 折算 U 静态收益（wei）：
   * 同上，待领+已领 TSK 价值侧 U
   */
  tskValueUsdtWei: string;
}

/** 托管解除记录列表响应（/game/user/GetCustodyExitRecords） */
export interface GetCustodyExitRecordsResponse {
  /** 符合条件的总条数 */
  total: number;
  records: CustodyExitRecordItem[];
}

/** 获取用户托管汇总响应（/game/user/GetUserCustodyInfo） */
export interface GetUserCustodyInfoResponse {
  /** 托管总量：当前在池本金（wei） */
  totalCustodyUsdtWei: string;
  /** 今日收益：静态 U（UTC0 日息流水日汇总，wei） */
  todayEarningsUsdtWei: string;
  /** 今日收益：TSK 价值侧 U（wei） */
  todayEarningsTskValueUsdtWei: string;
  /** 已领取 USDT 累计（含复投；领到余额为扣费后净额，wei） */
  claimedUsdtWei: string;
  /** 已领取 TSK 代币（wei；当前领取路径暂为 0，链上交付后更新） */
  claimedTskWei: string;
  /** 待领取 USDT（wei） */
  pendingUsdtWei: string;
  /** 待领取 TSK 折算 U 价值（wei） */
  pendingTskValueUsdtWei: string;
  /** 平台当月托管入金上限（wei） */
  platformMonthlyQuotaUsdtWei: string;
  /** 平台当月已用托管本金（wei） */
  platformMonthlyUsedUsdtWei: string;
  /** 我的在池本金（wei） */
  myCustodyPrincipalUsdtWei: string;
  /** 单账号入金托管上限（wei） */
  myCustodyMaxPerUserUsdtWei: string;
  /** 在池「余额入金口径」本金是否已达上限（Principal−Reinvested 合计；在池总额可更高） */
  myCustodyExceedsMaxLimit: boolean;
  /** 今日收益对应 UTC0 业务日（YYYYMMDD） */
  statDay: number;
}

/** 签署托管须知请求（/game/user/SignCustodyAgreement） */
export interface SignCustodyAgreementRequest {
  agreementVersion: string;
}

/** 签署托管须知响应 */
export interface SignCustodyAgreementResponse {
  ok: boolean;
}

/** 托管入金请求（/game/user/CustodyDeposit） */
export interface CustodyDepositRequest {
  amountUsdtWei: string;
  agreementVersion: string;
}

/**
 * 托管入金 `resultCode`（`/game/user/CustodyDeposit`，见 custodyUserApi）
 * 本接口无 `ok` 字段，以 `resultCode === 0` 判断成功。
 */
export enum CustodyDepositResultCode {
  /** 成功 */
  Success = 0,
  /** 金额非法 */
  AmountInvalid = 1,
  /** 低于单笔最小托管 */
  BelowMin = 2,
  /** 未签署须知 */
  AgreementNotSigned = 3,
  /** 超过单用户入金托管上限 */
  ExceedMaxPerUser = 4,
  /** USDT 余额不足 */
  InsufficientUsdt = 5,
  /** 主单状态不允许继续入金 */
  OrderStatusInvalid = 6,
  /** 主单 UTC 日与目标日不一致 */
  UtcDayMismatch = 7,
  /** 超过当月全局托管额度 */
  ExceedMonthlyQuota = 8,
  /** 其它托管写操作进行中 */
  Busy = 9,
  /** 服务端错误（可能 Terminate） */
  Exception = 99,
}

/** 托管入金响应 */
export interface CustodyDepositResponse {
  resultCode: CustodyDepositResultCode | number;
  resultMsg: string;
  mergedOrderId: string;
}

/** 退出托管请求（/game/user/CustodyExit） */
export interface CustodyExitRequest {
  mergedOrderId: string;
}

/** 退出托管 resultCode */
export enum CustodyExitResultCode {
  Success = 0,
  MissingMergedOrderId = 1,
  OrderNotFoundOrNotOwner = 2,
  NoPrincipalToExit = 3,
  StatusNotAllow = 4,
  HistoryOrderNotAllow = 5,
  ConcurrentConflict = 6,
  Busy = 7,
  Exception = 99,
}

/** 退出托管响应 */
export interface CustodyExitResponse {
  resultCode: CustodyExitResultCode | number;
  resultMsg: string;
  ok: boolean;
}

/** 领取托管收益请求（/game/user/CustodyClaim） */
export interface CustodyClaimRequest {
  mergedOrderId: string;
}

/** 领取托管收益响应 */
export interface CustodyClaimResponse {
  ok: boolean;
  resultMsg: string;
}

/** 一键复投请求（/game/user/CustodyReinvest） */
export interface CustodyReinvestRequest {
  agreementVersion: string;
}

/** 一键复投来源主单扣减明细 */
export interface CustodyReinvestSourceOrderItem {
  mergedOrderId: string;
  amountUsdtWei: string;
}

/**
 * 一键复投 `resultCode`（`/game/user/CustodyReinvest`，见 custodyUserApi）
 * `ok` 在 `resultCode === 0` 时为 true。
 */
export enum CustodyReinvestResultCode {
  /** 成功 */
  Success = 0,
  /** 未传 agreementVersion */
  MissingAgreementVersion = 1,
  /** 全账号无可复投待领 U */
  NoPendingUsdt = 2,
  /** 待领 U 合计低于复投门槛 */
  BelowMinReinvest = 3,
  /** 未签署须知 */
  AgreementNotSigned = 4,
  /** 目标主单 UTC 日不一致 */
  UtcDayMismatch = 5,
  /** 目标主单状态不允许 */
  TargetStatusInvalid = 6,
  /** 超过当月全局额度 */
  ExceedMonthlyQuota = 7,
  /** 其它托管写操作进行中 */
  Busy = 8,
  /** 服务端错误 */
  Exception = 99,
}

/** 一键复投响应 */
export interface CustodyReinvestResponse {
  resultCode: CustodyReinvestResultCode | number;
  resultMsg: string;
  ok: boolean;
  targetMergedOrderId?: string;
  reinvestedUsdtWei: string;
  reinvestBatchId: string;
  sourceOrders: CustodyReinvestSourceOrderItem[];
}

/** 每日日息发放记录请求（/game/user/GetCustodyDailyPayoutRecords） */
export interface GetCustodyDailyPayoutRecordsRequest {
  page?: number;
  pageSize?: number;
  mergedOrderId?: string;
}

/** 每日日息发放记录条目 */
export interface CustodyDailyPayoutRecordItem {
  id: string;
  mergedOrderId: string;
  time: number;
  statDay: string;
  onlyUsdt: string;
  tskValueUsdt: string;
}

/** 每日日息发放记录响应 */
export interface GetCustodyDailyPayoutRecordsResponse {
  total: number;
  records: CustodyDailyPayoutRecordItem[];
}

/** 领取/复投流水请求（/game/user/GetCustodyStaticClaimLines） */
export interface GetCustodyStaticClaimLinesRequest {
  sourceMergedOrderId?: string;
  page?: number;
  pageSize?: number;
}

/**
 * 静态奖励领取/复投流水条目（`GetCustodyStaticClaimLines` 的 `lines[]` 元素，非日息发放流水）
 * @see custodyUserApi — GetCustodyStaticClaimLines
 */
export interface CustodyStaticClaimLineItem {
  /** 流水 ID */
  id: string;
  /** `1` 领取到余额；`2` 复投 */
  kind: 1 | 2;
  /**
   * 来源主单 ID。
   * **kind=2（复投）** 时为 `reinvestBatchId`（非单一主单 id，明细见 `custodyMergedReinvestSourceLine`）
   */
  sourceMergedOrderId: string;
  /** 复投目标主单 ID（仅 kind=2） */
  targetMergedOrderId?: string;
  /** 创建时间（毫秒时间戳） */
  createTime: number;
  /** 静态 USDT 毛额（wei） */
  grossPendingStaticUsdtWei: string;
  /** 静态 USDT 手续费（wei） */
  feePendingStaticUsdtWei: string;
  /** 静态 USDT 净额（wei） */
  netPendingStaticUsdtWei: string;
  /**
   * TSK 价值侧毛额（折合 USDT 计价，wei）。
   * kind=1 领取时手续费为 0，净额等于毛额
   */
  grossPendingTskValueUsdtWei: string;
  /** TSK 价值侧手续费（折合 USDT 计价，wei） */
  feePendingTskValueUsdtWei: string;
  /** TSK 价值侧净额（折合 USDT 计价，wei） */
  netPendingTskValueUsdtWei: string;
  /** TSK 代币净额（wei）；kind=1 暂为 0，链上交付后补充 */
  netTskWei: string;
  /** TSK 代币手续费（wei）；kind=1 暂为 0，链上交付后补充 */
  feeTskWei: string;
  /** 复投本金 USDT（wei，仅 kind=2） */
  reinvestPrincipalUsdtWei?: string;
}

/** 领取/复投流水响应 */
export interface GetCustodyStaticClaimLinesResponse {
  lines: CustodyStaticClaimLineItem[];
}

// ===================== Fort Agent =====================

// ---------- 购买签名 ----------

export interface FortAgentPurchaseSignRequest {
  skuId: string;
  /** `usdt` 全额 USDT；`mixed` 混合购延期补 FUSD；`mixed_now` 混合购购买时立即扣 FUSD；`prepay` 预留 */
  paymentMode: "usdt" | "mixed" | "mixed_now" | "prepay";
  quantity: number;
}

/** 购买签名接口 `resultCode`（见接口文档 FortAgentPurchaseSign） */
export enum FortAgentPurchaseResultCode {
  /** 成功 */
  Success = 0,
  /** 无效的购买方式 */
  InvalidPaymentMethod = 1,
  /** SKU / 配置 ID 无效或未启用 */
  InvalidSkuOrDisabled = 2,
  /** 未绑定钱包 */
  WalletNotBound = 3,
  /** 收款地址未配置或非法 */
  RecipientInvalid = 4,
  /** 收款地址与购买者一致 */
  RecipientSameAsBuyer = 5,
  /** SKU 未到开售时间 */
  SkuNotStarted = 6,
  /** SKU 已过期 */
  SkuExpired = 7,
  /** 价格计算失败 */
  PriceCalculationFailed = 8,
  /** USDT 配置错误 */
  UsdtConfigError = 9,
  /** 签名服务拒绝，resultMsg 为详情 */
  SignServiceRejected = 10,
  /** 混合比例配置错误（MixedFusdShareBp 须在 1..9999） */
  MixedRatioConfigError = 11,
  /** 已售罄 */
  SoldOut = 12,
  /** 用户不支持混合购买 */
  UserDoesNotSupportMixed = 13,
  /** 上一笔购买签名处理中，请稍后重试 */
  PendingPurchaseSignature = 14,
  /** quantity 非法或超过单次上限 */
  InvalidQuantity = 15,
  /** mixed_now：游戏 Balance 不足以支付预扣的 FUSD（Balance 腿） */
  InsufficientMixedFusdGameNow = 16,
  /** mixed_now：WaitClaimFusdAmount 不足以支付预扣的 FUSD（待提现腿） */
  InsufficientMixedFusdWaitNow = 17,
  /** mixed_now：扣款未生效（如并发），请重试 */
  MixedNowFusdDeductNotApplied = 18,
}

/**
 * 多语言：`toast.fortAgent.purchase.result.*`（与枚举映射见 `useFortAgentPurchaseSign.ts` 中 `FORT_AGENT_PURCHASE_RESULT_I18N_KEY`）。
 */
export interface FortAgentPurchaseSignResponse {
  resultCode: FortAgentPurchaseResultCode;
  resultMsg: string;
  agentId: number;
  agentIds: number[];
  token: string;
  amount: string;
  recipient: string;
  deadline: number;
  nonce: number;
  signature: string;
  digest: string;
  skuId: string;
  paymentMode: string;
}

// ---------- 转让签名 ----------

export interface FortAgentTransferSignRequest {
  agentId: number;
  to: string;
}

/** 转让签名接口 `resultCode`（见接口文档 FortAgentTransferSign） */
export enum FortAgentTransferResultCode {
  Success = 0,
  WalletNotBound = 1,
  InvalidAgentId = 2,
  InvalidRecipientAddress = 3,
  NotOwnerOrAgentMissing = 4,
  SignServiceRejected = 5,
  ActivatedCannotTransfer = 6,
  InsufficientFusd = 7,
  CannotTransferToSelf = 8,
  PendingAgentOperation = 9,
}

/** 多语言 key 见 `useFortAgentTransferSign.ts` 中 `FORT_AGENT_TRANSFER_RESULT_I18N_KEY` */
export interface FortAgentTransferSignResponse {
  resultCode: FortAgentTransferResultCode;
  resultMsg: string;
  agentId: number;
  from: string;
  to: string;
  deadline: number;
  nonce: number;
  signature: string;
  digest: string;
  chainId: number;
  contract: string;
}

// ---------- 激活签名 ----------

export interface FortAgentActivateSignRequest {
  agentId: number;
}

export enum FortAgentActivateResultCode {
  Success = 0, //成功
  WalletNotBound = 1, //未绑定钱包
  InvalidAgentId = 2, //agentId 非法
  NotOwnerOrAgentMissing = 3, //Agent 不存在或非本人持有
  AlreadyActivated = 4, //已激活
  SignServiceRejected = 5, //签名服务拒绝
  InsufficientFusd = 6, //FUSD 余额不足
  PendingAgentOperation = 7,
  /** 只能激活一个 */
  OnlyOne = 8,
  /** 混合购延期 FUSD 未支付，请先调用 FortAgentPayMixedFusd */
  MixedFusdUnpaid = 9,
}

export interface FortAgentActivateSignResponse {
  resultCode: FortAgentActivateResultCode;
  resultMsg: string;
  agentId: number;
  owner: string;
  deadline: number;
  nonce: number;
  signature: string;
  digest: string;
  chainId: number;
  contract: string;
}

// ---------- 混合购延期 FUSD 中心化扣款（钱包对 message 签名）----------

export interface FortAgentPayMixedFusdRequest {
  agentId: number;
  /** 毫秒时间戳，签名后 2 分钟内有效 */
  payTick: number;
  /** 对 `formatFortAgentPayMixedFusdMessage(agentId, payTick)` 的签名（见 `@/lib/fortAgentPayMixedFusdSign`） */
  signature: string;
}

/** `FortAgentPayMixedFusd` 接口 `resultCode`；`0` 成功 */
export enum FortAgentPayMixedFusdResultCode {
  Success = 0,
  WalletNotBound = 1,
  InvalidAgentId = 2,
  AgentNotFoundOrOwned = 3,
  NotMixedMode = 4,
  AlreadyPaid = 5,
  NoFusdOwed = 6,
  ParseSignErr = 7,
  SignerErr = 8,
  ExpireSignErr = 9,
  InsufficientGameBalance = 10,
  Busy = 11,
  InsufficientWaitClaimFusd = 12,
  DeductConflict = 13,
}

/** 多语言 key 见 `useFortAgentPayMixedFusd.ts` 中 `FORT_AGENT_PAY_MIXED_FUSD_RESULT_I18N_KEY` */
export interface FortAgentPayMixedFusdResponse {
  resultCode: FortAgentPayMixedFusdResultCode;
  resultMsg?: string;
}

// ---------- SKU 配置 ----------

/** SKU 配置单条（见接口文档 GetFortAgentSkuConfig / FortAgentSkuConfigItem） */
export interface FortAgentSkuConfigItem {
  /** SKU 唯一标识 */
  skuId: string;
  /** 档位序号 */
  tier: number;
  /** 档位名称 */
  name: string;
  /** 基准价 USDT（18 位最小单位整数字符串） */
  basePriceUsdt: string;
  /** 权益1：托管交易资金加速，万分比 */
  aiManageAddSpeed: number;
  /** 权益2：静态奖励上限占本金百分比分子（÷100） */
  exitMultiple: number;
  /** 权益2：基础日利率，百万分比 */
  staticDailyRateBpms: number;
  /** 权益3：分发 AIF 价值的 USDT（整数字符串） */
  aifValueUsdt: string;
  /** 权益3：分发天数；`0` 表示服务端默认（如 200 天） */
  aifDistributeDays: number;
  /** 权益4：激活后赠送等级 */
  giveLevel: number;
  /** 权益4：持续天数；`0` 表示服务端默认（如 30 天） */
  giveLevelDurationDays: number;
  /** 总供应量 */
  supplyCap: number;
  /** 开售时间（毫秒）；`0` 表示不限制 */
  effectiveFrom: number;
  /** 结束时间（毫秒）；`0` 表示不限制 */
  effectiveTo: number;
  /** 混合支付时 FUSD 占基准价比例（万分比）；`0` 表示不支持 mixed */
  mixedFusdShareBp: number;
  /** 是否支持混合购买（由配置推导） */
  supportsMixed: boolean;
  /** 剩余可售（总供给 − 已售 − 占位） */
  leftSupplyCount: number;
  /** 真实已售数量 */
  sellCount: number;
  /** 当前售价 涨价后的 */
  sellPriceUsdt: string;
}

export interface GetFortAgentSkuConfigResponse {
  skus: FortAgentSkuConfigItem[];
}

// ---------- 我的 Agent ----------

/** Fort Agent 状态值 */
export const FORT_AGENT_STATUS = {
  /** 未激活 */
  PENDING: 0,
  /** 已激活 */
  ACTIVATED: 1,
  /** 已出局 */
  EXITED: 2,
} as const;

export type FortAgentStatus =
  (typeof FORT_AGENT_STATUS)[keyof typeof FORT_AGENT_STATUS];

/** 我的 Fort Agent 单条（见接口文档 MyFortAgentItem） */
export interface MyFortAgentItem {
  name: string;
  /** 链上 agentId */
  agentId: number;
  /** SKU 配置 ID */
  skuCode: string;
  /** `0` 未激活，`1` 已激活，`2` 已出局 */
  status: FortAgentStatus;
  /** 购买交易哈希 */
  purchaseTx: string;
  /** 支付方式：`usdt` | `mixed` | `mixed_now` */
  paymentMode: string;
  /** 应付 FUSD（整数字符串，wei） */
  purchasePayFusdWei: string;
  /** USDT 实付（整数字符串，最小单位） */
  purchasePayUsdtTokenWei: string;
  purchasePayTotalPrice: string; //实付总价
  /** FUSD 是否已扣款 */
  fusdPurchaseDeducted: boolean;
  /** 静态计息本金 USDT（整数字符串） */
  priceBasisUsdt: string;
  /** 激活时间（毫秒）；未激活为 `0` */
  activatedAt: number;
  /** 权益2：已累计静态 USDT */
  staticPaidUsdt: string;
  /** 权益2：静态上限 USDT */
  staticCapUsdt: string;
  /** 专属静态是否已结束 */
  staticStopped: boolean;
  /** 绑定钱包地址 */
  walletAddress: string;
  /** 首次购买人 uid */
  firstOwner: string;
  /** 创建时间（毫秒） */
  createdAt: number;
  /** 更新时间（毫秒） */
  updatedAt: number;
  /** 权益1：托管加速万分比快照 */
  aiManageAddSpeedBp: number;
  /** 权益3：AIF 价值 USDT 快照 */
  aifValueUsdt: string;
  /** 权益3：发放天数快照 */
  aifDistributeDays: number;
  /** 权益3：已累计发放 AIF 数量 */
  aifPaid: string;
  /** 权益3：已累计发放 AIF 对应 USDT */
  aifPaidValueUsdt: string;
  /** 权益3：已发放天数 */
  aifPaidDays: number;
  /** 权益4：赠送等级 */
  giftGiveLevel: number;
  /** 权益4：生效时间（毫秒） */
  giftGiveLevelStartAt: number;
  /** 权益4：失效时间（毫秒） */
  giftGiveLevelExpireAt: number;
  /** 权益2：出局倍数 */
  // TODO:
  exitMultiple: number;
  //
  purchasePayFusdFromGameBalanceWei: string; // 延期 FUSD 中从游戏 Balance 扣的额度（整数字符串）
  purchasePayFusdFromWaitClaimWei: string; // 延期 FUSD 中从 WaitClaim 扣的额度（整数字符串）
  /** 今日静态分红 USDT（wei 字符串；UTC0 自然日，未发放为 `"0"`） */
  todayStaticPayoutUsdt?: string;
  /** 今日已发放静态分红使用的日利率（万分比快照；未发放为 `0`） */
  todayStaticPayoutRateBpms?: number;
}

export interface GetMyFortAgentsResponse {
  agents: MyFortAgentItem[];
}

/** 获取用户联系信息（/game/user/GetUserContactProfile） */
export type GetUserContactProfileRequest = Record<string, never>;

export interface GetUserContactProfileResponse {
  /** 用户名称（收件人） */
  userName: string;
  /** 联系地址 */
  contactAddress: string;
  /** 联系方式 */
  contact: string;
}

/** 设置用户联系信息（/game/user/SetUserContactProfile） */
export interface SetUserContactProfileRequest {
  userName: string;
  contactAddress: string;
  contact: string;
}

export type SetUserContactProfileResponse = Record<string, never>;

/** 专属静态奖励发放记录（/game/user/GetFortAgentStaticPayoutRecords） */
export interface GetFortAgentStaticPayoutRecordsRequest {
  page: number;
  pageSize: number;
  /** 0 表示全部智能体 */
  agentId: number;
}

export interface FortAgentStaticPayoutRecordItem {
  id: string;
  agentId: number;
  bizDate: string;
  amountUsdt: string;
  rateBpms: number;
  /** 发放时团队等级 C 快照 */
  teamLevel: number;
  createTime: number;
}

export interface GetFortAgentStaticPayoutRecordsResponse {
  total: number;
  records: FortAgentStaticPayoutRecordItem[];
}

/** 权益3 AIF 按日释放发放记录（/game/user/GetFortAgentAifVestingPayoutRecords） */
export interface GetFortAgentAifVestingPayoutRecordsRequest {
  page: number;
  pageSize: number;
  /** 0 表示全部智能体 */
  agentId: number;
}

export interface FortAgentAifVestingPayoutRecordItem {
  id: string;
  agentId: number;
  bizDate: string;
  amountAif: string;
  valueUsdt: string;
  aifPriceUsdt: string;
  vestingDayIndex: number;
  createTime: number;
}

export interface GetFortAgentAifVestingPayoutRecordsResponse {
  total: number;
  records: FortAgentAifVestingPayoutRecordItem[];
}

// ===================== 资产余额 =====================

export interface BalanceItem {
  coinContract: string;
  total: string;
  waitClaimFusdAmount: string;
  gameFusdAmount: string;
  canUseUsdtAmount: string; //可使用USDT余额
  tuoGuanFreezeUsdtAmount: string; //托管冻结USDT余额
  ceLvFreezeUsdtAmount: string; //储备冻结USDT余额
}

export interface GetBalanceV2Response {
  items: BalanceItem[];
  tskWaitExchangeValueUsdt: string; //TSK 待兑换 USDT 余额
}

// ===================== 邀请等级 =====================

/** 与后端 `GetUserInviteLevelRequest` 对应，请求体为空对象 */
export type GetUserInviteLevelRequest = Record<string, never>;

/**
 * 与后端 `GetUserInviteLevelResponse` 对齐。
 * 带 `?` 的字段为 Go 中曾注释、后端可能后续开放的扩展字段。
 */

export interface GetUserInviteLevelResponse {
  address: string;
  /** 等级 */
  level: number;
  /** 直推人数 */
  directCount: number;
  /** 是否为有效用户 */
  isValidUser: boolean;
  /** 有效人数 */
  validUserCount: number;
  selfYj: string; //自己的业绩
  teamSmallYj: string; //团队小区业绩
  /** 团队总人数 */
  teamCount?: number;
}

/** 与后端 `GetInviteLevelConfigRequest` 对齐 */
export interface GetInviteLevelConfigRequest {
  coinContract: string;
}

/** 与后端 `InviteLevelConfigItem` 对齐 */
export interface InviteLevelConfigItem {
  id: string;
  level: number;
  coinContract: string;
  /** 团队业绩门槛（最小单位字符串） */
  teamYjAmount: string;
  /** 个人业绩门槛（最小单位字符串） */
  userYjAmount: string;
  rewardRatio: number; // 极差收益比率（万分比）
  rewardTotalRatio: number;
  /** 前端派生：极差收益百分比（例如 4500 -> 45） */
  rewardRatioPercent?: number;
  /** 前端派生：该等级全球分红权重（万分比） */
  globalWeightBp?: number;
  /** 前端派生：全球分红比率（万分比） */
  globalDividendRatioBp?: number;
  /** 前端派生：全球分红百分比 */
  globalDividendRatioPercent?: number;
}

/** 托管动态奖励比例配置（万分比） */
export interface CustodyDynamicInfo {
  totalRatio: number;
  teamRatio: number;
  parentRatio: number;
  globalRatio: number;
}

/** 全球奖励权重项（GetInviteLevelConfigResponse.globalRatios） */
export interface CustodyDynamicGlobalLevelShare {
  level: number;
  /** 权重（万分比） */
  shareBp: number;
}

/** 与后端 `GetInviteLevelConfigResponse` 对齐 */
export interface GetInviteLevelConfigResponse {
  items: InviteLevelConfigItem[];
  globalRatios?: CustodyDynamicGlobalLevelShare[];
  validUserLimit?: string;
  parentTierRatios?: number[];
  parentAiStrategyRatio?: number;
  /** 后端 JSON tag: `parentCustodyRatio` */
  parentCustodyRatio?: CustodyDynamicInfo;
}

// ===================== 邀请团队成员 =====================

/** 与后端 `GetUserInviteTeamRequest` 对齐 */
export interface GetUserInviteTeamRequest {
  coinContract: string;
}

/**
 * 与后端 `InviteTeamItem` 对齐（JSON 字段名与 Go `json` tag 一致）。
 */
export interface InviteTeamItem {
  address: string;
  /** 团队等级 */
  level: number;
  /** 个人业绩 */
  selfYj: string;
  /** 上级地址 */
  parent: string;
  /** 团队人数 */
  teamCount: number;
  /** 今日团队增加人数 */
  todayTeamCount: number;
  /** 团队总业绩 */
  teamTotalYj: string;
  /** 今日新增团队业绩 */
  todayTeamYj: string;
  /** 钱包地址 */
  walletAddress: string;
  /** 注册时间 */
  registerTime: number;
}

/** 与后端 `GetUserInviteTeamResponse` 对齐 */
export interface GetUserInviteTeamResponse {
  items: InviteTeamItem[];
  coinContract: string;
}

// ===================== 团队动态收益 =====================

export interface DynamicRewardAmountView {
  onlyUsdt: string;
  tskValueUsdt: string;
  totalUsdt: string;
}

export interface DynamicRewardBreakdownView {
  total: DynamicRewardAmountView;
  team: DynamicRewardAmountView;
  parent: DynamicRewardAmountView;
  global: DynamicRewardAmountView;
}

export interface GetUserDynamicRewardInfoRequest {
  /** 1=待领取；2=今日；3=已领取 */
  type: 1 | 2 | 3;
  coinContract?: string;
}

export interface GetUserDynamicRewardInfoResponse {
  type: 1 | 2 | 3;
  coinContract: string;
  statDay?: string;
  rewards: DynamicRewardBreakdownView;
}

export interface GetUserDynamicRewardDailyRecordsRequest {
  page?: number;
  pageSize?: number;
  coinContract?: string;
}

export interface DynamicRewardDailyRecordItem {
  id: string;
  time: number;
  statDay: string;
  rewardType: 1 | 2 | 3;
  onlyUsdt: string;
  tskValueUsdt: string;
}

export interface GetUserDynamicRewardDailyRecordsResponse {
  total: number;
  coinContract: string;
  records: DynamicRewardDailyRecordItem[];
}

export interface GetUserDynamicRewardClaimRecordsRequest {
  page?: number;
  pageSize?: number;
  coinContract?: string;
}

export interface DynamicRewardClaimRecordItem {
  id: string;
  time: number;
  onlyUsdt: string;
  tskValueUsdt: string;
  tskAmount: string;
}

export interface GetUserDynamicRewardClaimRecordsResponse {
  total: number;
  coinContract: string;
  records: DynamicRewardClaimRecordItem[];
}

/** `/game/user/ClaimDynamicReward` 领取团队动态奖励 resultCode */
export enum ClaimDynamicRewardResultCode {
  /** 成功 */
  Ok = 0,
  /** 没有可领取的 */
  NothingToClaim = 1,
  /** 没有找到记录 */
  ReferRewardNotFound = 2,
  /** 待领取状态已变更，请刷新后再试 */
  PendingChanged = 3,
  /** 操作太频繁 */
  OperationInProgress = 4,
  /** 服务器异常 */
  Server = 99,
}

/** 一次性领取全部可领动态奖励（仅纯 U，请求体为空） */
export type ClaimDynamicRewardRequest = Record<string, never>;

/** `/game/user/ClaimDynamicReward` 领取团队动态奖励响应 */
export interface ClaimDynamicRewardResponse {
  resultCode: ClaimDynamicRewardResultCode | number;
  resultMsg: string;
  ok: boolean;
  coinContract: string;
  /** 本次领取明细（当前仅 onlyUsdt 有值） */
  claimedRewards: DynamicRewardBreakdownView;
}

// ===================== 充提/划转记录 =====================

export interface GetWithdrawAndRechargeRecordRequest {
  includeStartTime: number;
  excludeEndTime: number;
  limit: number;
  /** 0-all 1-recharge 2-withdraw 3-buyToken 4-fortuna划转 5-TransferIn 6-TransferOut */
  type: number;
}

export interface WithdrawAndRechargeRecordItem {
  outTradeNo: string;
  /** 1-recharge 2-withdraw 3-buyToken 4-fortuna划转 5-TransferIn 6-TransferOut */
  type: number;
  amount: string;
  txId: string;
  createTime: number;
  /** -1-fail 0-pending 1-success */
  status: number;
  failReason: string;
  coinContract: string;
  costCoinContract: string;
  costAmount: string;
  transferDstAddress: string;
  chainId: number;
  bscTxId: string;
}

export interface GetWithdrawAndRechargeRecordResponse {
  waitCheckItems: WithdrawAndRechargeRecordItem[];
  items: WithdrawAndRechargeRecordItem[];
}

// 提交充值或提现交易请求
export interface SubmitWithdrawOrDepositTxRequest {
  amount: string; // 金额（字符串格式，使用最小单位）
  txId: string; // 交易ID（用户在链上发起的交易哈希）
  opCode: number; // 操作代码：1-deposit 2-withdraw 3-buyToken
  coinContract: string; // 币种合约地址
  costToken?: string; // 花费的币种合约地址（buyToken时使用）
  costTokenAmount?: string; // 花费的金额（buyToken时使用）
}

// 提交充值或提现交易响应
export interface SubmitWithdrawOrDepositTxResponse {
  resultCode: number; // 结果代码：0-成功
}

// ===================== FUSD 内部转账 TransferFusd =====================

/** TransferFusd 接口返回的 `resultCode` */
export enum TransferFusdResultCode {
  /** 成功 */
  Success = 0,
  /** 余额不足 */
  Insufficient = 1,
  /** 通道关闭 */
  Close = 2,
  /** amount 不符合 */
  AmountErr = 3,
  /** 签名已过期（发起时间与当前时间超过约 2 分钟） */
  ExpireSignErr = 4,
  /** 合约地址错误 */
  ContractErr = 5,
  /** 签名解析错误 */
  ParseSignErr = 6,
  /** 签名人与发起者不一致 */
  SignerErr = 7,
  /** 目标地址不存在 */
  ToNotExistErr = 8,
  /** 不能自己转给自己 */
  ToSelfErr = 9,
  /** 异常，转账失败 */
  Exception = 10,
  /** 与 FUSD 转出相关接口互斥，请稍后重试 */
  Busy = 11,
  /** AIF/AIFX 仅允许同一伞下内转 */
  UmbrellaErr = 12,
  /** 账号冻结 */
  AccountFreeze = 888,
}

export interface TransferFusdRequest {
  /** 金额（字符串，与后端约定格式一致，一般为最小单位或十进制字符串） */
  amount: string;
  /** 代币合约地址 */
  coinContract: string;
  /** 转账目标地址 */
  toAddress: string;
  /** 发起时间戳（毫秒），签名后约两分钟内有效 */
  transferTick: number;
  /** 钱包签名；Message = 金额 + 合约地址 + 转账目标地址 + 时间戳 的字符串拼接 */
  signature: string;
}

export interface TransferFusdResponse {
  resultCode: TransferFusdResultCode;
}

// ===================== 余额兑换（Balance Swap） =====================

/** 余额兑换请求（/game/user/BalanceUsdtSwapTsk, /game/user/BalanceTskSwapUsdt） */
export interface BalanceSwapRequest {
  /** 前端生成的订单号：正整数字符串，且不能重复 */
  orderId: string;
  /** 输入数量（最小单位整数字符串，必须 > 0） */
  amount: string;
  /** 最小可接受输出数量（最小单位整数字符串，可为 "0"） */
  minOut: string;
  /** 签名时间戳（毫秒），后端约 2 分钟有效期 */
  signTick: number;
  /** 对约定 message 的 personal_sign 签名 */
  signature: string;
}

/** 余额兑换 resultCode */
export enum BalanceSwapResultCode {
  /** 已受理，进入后台处理 */
  Success = 0,
  /** 参数错误：orderId/amount/minOut 不合法 */
  InvalidParams = 1,
  /** 未绑定钱包或钱包地址无效 */
  WalletNotBound = 2,
  /** 签名过期（signTick 超时） */
  SignExpired = 3,
  /** 签名错误或签名人不是绑定钱包 */
  InvalidSignature = 4,
  /** 后端账本余额不足 */
  InsufficientBalance = 5,
  /** orderId 重复 */
  DuplicateOrderId = 6,
  /** 用户已有 waiting/processing 的兑换订单 */
  HasPendingOrder = 7,
  /** 账号被冻结 */
  AccountFrozen = 888,
  /** 服务端内部错误 */
  ServerError = 999,
}

/** 余额兑换响应 */
export interface BalanceSwapResponse {
  /** 业务结果码；0 成功，其余见 BalanceSwapResultCode */
  resultCode: BalanceSwapResultCode | number;
  /** 业务结果说明 */
  resultMsg: string;
  /** 回显订单号 */
  orderId: string;
}

// ===================== CEX 未平仓订单列表 =====================

/** `/game/cex/GetOpenOrderList` 请求体（分页） */
export interface GetOpenOrderListRequest {
  /** 页码；`<1` 时按 1 处理 */
  page: number;
  /** 每页条数；默认 20，最大 500（以服务端实际约束为准） */
  pageSize: number;
}

/** 已平仓订单筛选模式 */
export type ClosedOrderMode = "all" | "auto" | "manual";

/** 费用信息（客户端视角，对齐后端 `PayFeeInfo2Client`） */
export interface PayFeeInfo2Client {
  /** FUSD 币种合约地址（待提现 FUSD 扣/退用） */
  fusdCoinContract: string;
  /** 本次涉及 FUSD 的数量（wei，与币种精度一致） */
  paidFusdAmount: string;
  /** 上述 FUSD 腿按当时价折合的 USDT 价值（wei） */
  paidFusdValueUsdtAmount: string;
  /** 本次从 USDT 游戏余额扣/退的数量（wei） */
  paidUsdtAmount: string;
  /** 本笔记账名义「总价值 U」（USDT 计价 wei） */
  totalUsdtAmount: string;
}

/**
 * 订单列表项：`cex.CexRunningOrderListItem`
 *
 * 关键字段说明（与后端字段语义对齐）：
 * - SignalFee: 算力侧费用；仅取信号未下单时等于 BeforeSignalPrePayFee，下单成功后为按交易量的算力费快照
 * - TradeFee: 交易侧费用；下单成功后按交易量的交易手续费快照
 * - IsFinishShare: 是否完成利润分配（后端 bson 字段为 IsFinishSplit）
 * - CloseSplitStaticUsdt: 盈利场景下用户静态分成（70%）
 * - CloseSplitStaticOnlyUsdt: 盈利场景下静态奖励 U（已入用户余额）
 * - CloseSplitStaticTskU: 盈利场景下静态拟兑 TSK 的 U 价值
 * - CloseSplitDynamicUsdt: 盈利场景下动态 U（待 cexCloseDynamicRewardPending 细分）
 * - CloseSplitDynamicTskU: 盈利场景下动态拟兑 TSK 的 U 价值（同上）
 * - CloseSplitTreasuryTskU: 盈利场景下国库拟兑 TSK 的 U 价值（仅记账）
 * - CloseSplitPlatUsdt: 盈利场景下项目方 U（已转项目方 uid）
 * - CloseSplitLossUsdt: 亏损场景下 Usdt
 * - CloseSplitLossUserTskx: 亏损场景下补用户静态 TSKx 数量（名义）
 * - CloseSplitLossDynamicTskx: 亏损场景下动态池 TSKx（待下发表细分）
 */
export interface CexRunningOrderListItem {
  /** 记录 ID */
  id: string;
  /** 用户 ID（字符串） */
  uid: string;
  /** 策略 ID */
  strategyId: string;
  /** 币种/交易对（如 BTCUSDT） */
  symbol: string;
  /** 保证金 */
  amount: number;
  /** 方向：sell / buy */
  action: string;
  /** 杠杆倍数 */
  leverage: number;
  /** 风险偏好 ID */
  riskId?: number;
  /** 总交易量 */
  tradingVolume: number;
  /** 平仓收益 */
  closeProfit: number;
  /** 盈亏 */
  pnl: number;
  /** 开仓价位 */
  openAmount: number;
  /** 开仓时间（Unix 毫秒） */
  openTime: number;
  /** 止盈价 */
  takeProfit: number;
  /** 止损价 */
  stopLoss: number;
  /** 平仓时间（Unix 毫秒；未平仓通常为 0） */
  closeTime: number;
  /** 是否自动下单 */
  autoOrder: boolean;
  /** 是否已开仓（对应库字段 Open） */
  isOpen: boolean;
  /** 创建时间（Unix 毫秒） */
  createTime: number;
  /** 更新时间（Unix 毫秒） */
  updateTime: number;
  /** 是否已完成利润分配（后端 bson 字段为 IsFinishSplit） */
  isFinishShare: boolean;
  /** 订单静态收益比例（千分比） */
  orderStaticRatio: number;
  /** 订单静态纯 U 比例（千分比） */
  orderStaticOnlyURatio: number;
  /** 订单静态 U 转 TSK 比例（千分比） */
  orderStaticU2TskRatio: number;
  /** 订单亏损后获得 TSKx 比例（千分比） */
  orderCloseLossTskxRatio: number;
  /** 盈利：用户静态分成 70% */
  closeSplitStaticUsdt: number;
  /** 盈利：静态奖励 U（已入用户余额） */
  closeSplitStaticOnlyUsdt: number;
  /** 盈利：静态拟兑 TSK 的 U 价值 */
  closeSplitStaticTskU: number;
  /** 盈利：动态 U（待 cexCloseDynamicRewardPending 细分） */
  closeSplitDynamicUsdt: number;
  /** 盈利：动态拟兑 TSK 的 U 价值（同上） */
  closeSplitDynamicTskU: number;
  /** 盈利：国库拟兑 TSK 的 U 价值（仅记账） */
  closeSplitTreasuryTskU: number;
  /** 盈利：项目方 U（已转项目方 uid） */
  closeSplitPlatUsdt: number;
  /** 亏损：Usdt */
  closeSplitLossUsdt: number;
  /** 亏损：补用户静态 TSKx 数量（名义） */
  closeSplitLossUserTskx: number;
  /** 亏损：动态池 TSKx（待下发表细分） */
  closeSplitLossDynamicTskx: number;
  /** 交易侧费用：下单成功后按交易量的交易手续费快照 */
  tradeFee: PayFeeInfo2Client;
  /** 算力侧费用：仅取信号未下单时等于 BeforeSignalPrePayFee，下单成功后为按交易量的算力费快照（后端字段名保留 `signaleFee`） */
  signaleFee: PayFeeInfo2Client;
  truthPnl: number; //真实盈亏
  closeAmount: number; //平仓价
  tradeFeeRateBps: number; //交易手续费率（千分比）
  signalFeeRateBps: number; //算力费率（千分比）
  aiManageAddSpeedBp: number; //托管交易资金加速万分比
  subsidyPaidUsdt: number; //补偿
}

/** `/game/cex/GetOpenOrderList` 响应体 */
export interface GetOpenOrderListResponse {
  /** 结果码：0 成功，10 异常（以服务端定义为准） */
  resultCode: number;
  /** 结果文案 */
  resultMsg: string;
  /** 总条数 */
  total: number;
  /** 未平仓订单列表 */
  items: CexRunningOrderListItem[];
}

/** `/game/cex/GetClosedOrderList` 请求体（分页 + 下单模式过滤） */
export interface GetClosedOrderListRequest extends GetOpenOrderListRequest {
  /** all 全部 | auto 自动 | manual 手动；空或未识别按 all */
  orderMode: ClosedOrderMode;
}

/** `/game/cex/GetClosedOrderList` 响应体（同 GetOpenOrderListResponse） */
export type GetClosedOrderListResponse = GetOpenOrderListResponse;

// ===================== CEX 风险偏好 =====================

/** 与后端 `AiRiskPreferenceDTO` 对齐 */
export interface AiRiskPreferenceItem {
  /** 风险偏好 ID */
  id: number;
  /** 风险档位名称（如：稳健型/进取型） */
  name: string;
  /** 风险类型（枚举值，具体语义以后端定义为准） */
  type: number;
  /** 最低资金要求 */
  amountRequire: number;
  /** 最低杠杆要求 */
  leverRequire: number;
  /** 最大可用杠杆 */
  maxLever: number;
  /** 创建时间（服务端当前返回为日期字符串） */
  createTime: string;
  /** 更新时间（服务端当前返回为日期字符串） */
  updateTime: string;
}

/** 与后端 `/game/cex/GetRiskList` 返回结构对齐 */
export interface GetRiskListResponse {
  /** 结果码（0 通常为成功，其他值见服务端约定） */
  resultCode: number;
  /** 风险偏好列表 */
  items: AiRiskPreferenceItem[];
}

// ===================== CEX 获取信号 =====================

/** `/game/cex/GetSignal` 请求体（对应后端 `GetSignalRequest`） */
export interface GetSignalRequest {
  /** 计价/扣费语境下的币种（如 USDT） */
  coin: string;
  /** 价格或金额口径（透传上游） */
  price: number;
  /** 风险偏好 ID（对应 `GetRiskList.items[].id`） */
  riskId: number;
  /** 标的/交易对描述（如 ETH/BTC） */
  symbol: string;
  /** 风险类型（与风险列表项 `type` 一致） */
  type: number;
}

/** `db.AiAgentDTO`（见 API.md 附录 A） */
export interface AiAgentDTO {
  /** 交易对，如 BTCUSDT */
  symbol: string;
  /** 市场结构：range / trending / breakout */
  marketRegime: string;
  /** 5 分钟 ATR */
  atr5m: number;
  /** 波动分档：high / medium / low */
  volLevel: string;
  /** 噪声评分 */
  noiseScore: number;
  /** 噪声保护模式 */
  noiseGuardMode: string;
  /** 近期高点参考价 */
  recentHigh: number;
  /** 近期低点参考价 */
  recentLow: number;
  /** 买方强度 0-100 */
  buyStrength: number;
  /** 卖方强度 0-100 */
  sellStrength: number;
  /** 报价成交量比率 */
  quoteVolumeRatio: number;
  /** 成交笔数比率 */
  tradesRatio: number;
  /** 信号质量档：strong / normal / noise */
  signalQualityTier: string;
  /** 置信等级 1-5 */
  confidenceLevel: number;
  /** 最终评分 */
  finalScore: number;
  /** 置信度 0-1 */
  confidence: number;
  /** 风险标签摘要 */
  riskLabel: string;
  /** 风险收益比 RR */
  rr: number;
  /** 入场价 */
  entryPrice: number;
  /** 止损价 */
  stopLoss: number;
  /** 止盈价 */
  takeProfit: number;
  /** 仓位价值（USDT） */
  positionValueUSDT: number;
  /** 杠杆倍数 */
  leverage: number;
  /** 止盈预计盈亏（USDT） */
  takeProfitPnLUSDT: number;
  /** 止损预计盈亏（USDT） */
  stopLossPnLUSDT: number;
  /** 最大亏损绝对值（USDT） */
  maxLossUSDT: number;
  /** 是否触发 Hold 覆盖 */
  holdTrade: boolean;
  /** Hold 覆盖动作 */
  holdAction: string;
  /** Hold 原因 */
  holdReason: string;
  /** 最终动作 buy/sell/hold */
  action: string;
}

/** `db.AiSignalReturnDTO`（见 API.md 附录 B） */
export interface AiSignalReturnDTO {
  /** 策略/记账唯一 ID（PlaceOrder 时即 strategyId） */
  id: string;
  /** 用户 ID */
  userId: number;
  /** 交易币种 */
  symbol: string;
  /** buy/sell/hold-buy/hold-sell */
  action: string;
  /** 原始方向 */
  originalAction: string;
  /** 入场估计价 */
  entryPrice: number;
  /** 止损价 */
  stopLoss: number;
  /** 止损百分比 */
  stopLossPercent: number;
  /** 止盈价 */
  takeProfit: number;
  /** 止盈百分比 */
  takeProfitPercent: number;
  /** 固定杠杆 */
  leverage: number;
  /** 建议仓位金额 */
  positionValue: number;
  /** Unix 毫秒时间戳 */
  timestamp: number;
  /** AI 密文 */
  codeAI: string;
  /** AI 账户 ID */
  accountId: number;
  /** 是否用户主动下单：0 是 1 否 */
  type: number;
  /** 用户是否已开仓 */
  open: boolean;
  /** 预期盈利（USDT） */
  takeProfitPnLUSDT: number;
  /** 预期亏损（USDT） */
  stopLossPnLUSDT: number;
  /** 策略综合评分 */
  finalScore: string;
  /** 情绪价值描述 */
  content: string;
  /** Agent 详情（附录 A） */
  aiAgentDTO: AiAgentDTO | null;
  /** 用户选择方向 */
  selectAction: string;
  /** 风险偏好 ID */
  riskId: number;
  /** 上游原始策略 ID */
  originalStrategyId: string;
  /** 候选动作 1 */
  action_1: string;
  /** 候选动作 2 */
  action_2: string;
  /** 候选动作 3 */
  action_3: string;
  /** 权重 1 */
  weight_1: string;
  /** 权重 2 */
  weight_2: string;
  /** 权重 3 */
  weight_3: string;
  /** 候选杠杆 1 */
  leverage_1: number;
  /** 候选杠杆 2 */
  leverage_2: number;
  /** 候选杠杆 3 */
  leverage_3: number;
  /** 候选入场价 1 */
  entryPrice_1: number;
  /** 候选入场价 2 */
  entryPrice_2: number;
  /** 候选止损 1 */
  stopLoss_1: number;
  /** 候选止损 2 */
  stopLoss_2: number;
  /** 候选止盈 1 */
  takeProfit_1: number;
  /** 候选止盈 2 */
  takeProfit_2: number;
  /** 候选止盈比例 1 */
  takeProfitPercent_1: number;
  /** 候选止盈比例 2 */
  takeProfitPercent_2: number;
  /** 候选止损比例 1 */
  stopLossPercent_1: number;
  /** 候选止损比例 2 */
  stopLossPercent_2: number;
  /** 候选止盈盈亏 1 */
  takeProfitPnLUSDT_1: number;
  /** 候选止盈盈亏 2 */
  takeProfitPnLUSDT_2: number;
  /** 候选止损盈亏 1 */
  stopLossPnLUSDT_1: number;
  /** 候选止损盈亏 2 */
  stopLossPnLUSDT_2: number;
}

/** `/game/cex/GetSignal` resultCode */
export enum GetSignalResultCode {
  /** 成功，信号字段可直接读取 */
  Success = 0,
  /** 余额不足（预扣失败） */
  InsufficientBalance = 1,
  /** 上游取信号失败（已退款或待退款） */
  UpstreamFailed = 2,
  /** 请求太频繁 */
  Concurrent = 3,
  /** 开仓数量达到上限 */
  MaxOpenOrders = 4,
  /** OKX 交易账户可用/现金比例过低 */
  OkxAvailCashRatio = 5,
  ChannelClose = 6, //渠道关闭
  /** 未归类异常 */
  Exception = 10,
}

/** `GetSignalResponse.Klines[]`（1m K 线） */
export interface KlineInfo {
  /** 业务主键：BuildOkxSpotKline1mId(instId, OpenTime) */
  id: string;
  /** OKX 产品 ID，如 BTC-USDT */
  instId: string;
  /** 基础币符号：BTC / ETH / SOL / BNB（不含 -USDT） */
  base: string;
  /** K 线周期，固定 1m */
  bar: string;
  /** K 线开盘时间（UTC，毫秒时间戳） */
  openTime: number;
  /** 开盘价（USDT） */
  open: number;
  /** 最高价 */
  high: number;
  /** 最低价 */
  low: number;
  /** 收盘价 */
  close: number;
  /** 成交量（基础币） */
  vol: number;
  /** 是否已完结 K：1 已收盘，0 未收盘 */
  confirm: number;
  /** 首次写入时间（毫秒） */
  createTime: number;
  /** 最近同步时间（毫秒） */
  updateTime: number;
}

/** `/game/cex/GetSignal` 响应体（顶层字段 + 平铺 `AiSignalReturnDTO`） */
export type GetSignalResponse = AiSignalReturnDTO & {
  /** 结果码 */
  resultCode: GetSignalResultCode | number;
  /** 结果文案 */
  resultMsg: string;
  /** 计费单 ID */
  chargeRecordId: string;
  /** 1m K 线数据 */
  klines: KlineInfo[];
};

// ===================== CEX 预估下单费用 =====================

/** `/game/cex/EstimateOrderFees` 请求体 */
export interface EstimateOrderFeesRequest {
  /**
   * 策略 ID。
   * 与 `GetSignal` 返回、`PlaceOrder` 中 `orderData.id` 保持一致。
   */
  strategyId: string;
  /** 本次下单杠杆倍数 */
  leverage: number;
}

/** 预扣差额方向 */
export type EstimateOrderFeesDeltaDirection =
  | "supplement"
  | "refund"
  | "balanced";

/** `/game/cex/EstimateOrderFees` 响应体 */
export interface EstimateOrderFeesResponse {
  /** 结果码（0 通常为成功，其他值由服务端定义） */
  resultCode: number;
  /** 结果文案 */
  resultMsg: string;
  /** 计费单 Mongo `_id`，用于计费对账 */
  chargeRecordId: string;

  /**
   * 交易量（USDT 人类值）。
   * 与 `AiSignalReturnDTO.Vol()` 一致：`leverage * positionValue`。
   */
  tradingVolume: number;

  /** 本笔计费单锁定的交易费率（基点 bps） */
  tradeFeeRateBps: number;
  /** 本笔计费单锁定的算力费率（基点 bps） */
  signalFeeRateBps: number;

  /**
   * 取信号前预扣名义总价值（USDT 人类值）。
   * 对应 `BeforeSignalPrePayFee.TotalUsdtAmount`。
   */
  prechargedNominalUsdt: number;

  /** 预估交易手续费（USDT 人类值） */
  estimatedTradeFeeUsdt: number;
  /** 预估算力手续费（USDT 人类值） */
  estimatedSignalFeeUsdt: number;
  /** 预估总手续费（USDT 人类值） */
  estimatedTotalFeesUsdt: number;

  /**
   * 相对预扣名义需补的 USDT（>=0）。
   * 与 `PlaceOrder` 的 `shortfall=max(0,totalWei-firstNominal)` 同口径。
   */
  supplementFeeUsdt: number;
  /**
   * 相对预扣名义多出的 USDT（>=0）。
   * 实际结算按服务端 settle 逻辑执行“多退少补”。
   */
  refundFeeUsdt: number;
  /** 预扣差额方向：补缴/退款/平衡 */
  deltaDirection: EstimateOrderFeesDeltaDirection | string;
}

// ===================== CEX 下单 =====================

/** `/game/cex/PlaceOrder` 请求体 */
export interface PlaceOrderRequest {
  /** 策略唯一 ID（来自 `GetSignal` 返回的 `id`） */
  strategyId: string;
  /** 用户最终选择方向：buy / sell / hold */
  action: string;
  /** 入场估计价（如 1m 收盘） */
  entryPrice: number;
  /** 止损价 */
  stopLoss: number;
  /** 止损百分比 */
  stopLossPercent: number;
  /** 止盈价 */
  takeProfit: number;
  /** 止盈百分比 */
  takeProfitPercent: number;
  /** 固定杠杆 */
  leverage: number;
  /** 建议仓位金额 */
  positionValue: number;
}

/** `/game/cex/PlaceOrder` resultCode */
export enum PlaceOrderResultCode {
  /** 成功 */
  Success = 0,
  /** 信号/计费状态不允许下单（如未命中、已使用等） */
  SignalOrBillingStateInvalid = 2,
  /** 预扣余额不足 */
  InsufficientPrechargedBalance = 3,
  OkxAvailCashRatio = 5,
  ChannelClose = 6,
  /** 异常（含上游失败、落库失败等） */
  Exception = 10,
}

/** `/game/cex/PlaceOrder` 响应体 */
export interface PlaceOrderResponse {
  /** 结果码 */
  resultCode: PlaceOrderResultCode | number;
  /** 结果文案 */
  resultMsg: string;
}

// ===================== CEX 平仓 =====================

/** `/game/cex/ClosePosition` 请求体 */
export interface ClosePositionRequest {
  /** 订单/策略 ID */
  strategyId: string;
}

/** `/game/cex/ClosePosition` resultCode */
export enum ClosePositionResultCode {
  /** 成功 */
  Success = 0,
  /** 订单不存在 */
  OrderNotFound = 1,
  /** 非本人订单 */
  NotOwner = 2,
  /** 已平仓 */
  AlreadyClosed = 3,
  /** 调用交易侧失败 */
  UpstreamFailed = 4,
  /** 其它异常 */
  Exception = 10,
}

/** `/game/cex/ClosePosition` 响应体 */
export interface ClosePositionResponse {
  /** 结果码 */
  resultCode: ClosePositionResultCode | number;
  /** 结果文案 */
  resultMsg: string;
}

// ===================== CEX 用户盈亏汇总 =====================

/** `/game/cex/GetUserCexPnlSummary` 请求体（空对象） */
export interface GetUserCexPnlSummaryRequest {}

/** `/game/cex/GetUserCexPnlSummary` resultCode */
export enum GetUserCexPnlSummaryResultCode {
  /** 成功 */
  Success = 0,
  /** 异常 */
  Exception = 10,
}

/** `/game/cex/GetUserCexPnlSummary` 响应体 */
export interface GetUserCexPnlSummaryResponse {
  /** 结果码 */
  resultCode: GetUserCexPnlSummaryResultCode | number;
  /** 结果文案 */
  resultMsg: string;
  /** 本次「今日」对应的业务日 YYYYMMDD（UTC0） */
  statDay: number;
  /** 今日全交易对盈亏之和（USDT 人类值） */
  todayPnl: number;
  /** 累计全交易对盈亏之和（USDT 人类值） */
  cumulativePnl: number;
}

// ===================== 用户自动交易亏损补偿池2 =====================

/** `/game/cex/GetUserAutoTradeLossCompPool2Info` 请求体（空对象） */
export interface GetUserAutoTradeLossCompPool2InfoRequest {}

/** `/game/cex/GetUserAutoTradeLossCompPool2Info` resultCode */
export enum GetUserAutoTradeLossCompPool2InfoResultCode {
  /** 成功 */
  Success = 0,
  /** 异常 */
  Exception = 10,
}

/** `/game/cex/GetUserAutoTradeLossCompPool2Info` 响应体 */
export interface GetUserAutoTradeLossCompPool2InfoResponse {
  /** 结果码 */
  resultCode: GetUserAutoTradeLossCompPool2InfoResultCode | number;
  /** 结果文案 */
  resultMsg: string;
  /** 累计亏损：AI 自动单全历史净亏（USDT，正数） */
  cumulativeLossUsdt: number;
  /** 已补偿（TSK 价值，折合 USDT） */
  compensatedTskValueUsdt: number;
  /** 待补偿 = 累计亏损 - 已补偿 */
  pendingCompUsdt: number;
  /** 预估下次补偿（待补偿 × 最高补贴率） */
  estimatedNextCompUsdt: number;
  /** 预估补贴比例（%，如 2.1） */
  estimatedCompRatePercent: number;
}

/** `/game/cex/GetUserAutoTradeLossCompPool2Records` 请求体 */
export interface GetUserAutoTradeLossCompPool2RecordsRequest {
  /** 页码，从 1 起 */
  page?: number;
  /** 每页条数，默认 20，最大 100 */
  pageSize?: number;
}

/** 池2补偿发放记录 status：0-发放中 | 1-已发放 */
export enum AutoTradeLossCompPool2RecordStatus {
  Distributing = 0,
  Issued = 1,
}

/** 单条池2补偿发放记录 */
export interface AutoTradeLossCompPool2RecordItem {
  /** 奖励发放时待补偿金额（USDT） */
  pendingCompUsdt: number;
  /** 补偿比例（%，如 2.1） */
  compRatePercent: number;
  /** 获得 TSK 价值（折合 USDT） */
  tskValueUsdt: number;
  /** 发放获得 TSK 数量（最小单位 wei，后端可能为 number 或 string） */
  tskAmount: number | string;
  /** 创建时间（UTC 毫秒） */
  createTime: number;
  /** 补偿日期 YYYYMMDD */
  compDate: string;
  /** 0-发放中 | 1-已发放 */
  status: AutoTradeLossCompPool2RecordStatus | number;
}

/** `/game/cex/GetUserAutoTradeLossCompPool2Records` resultCode */
export enum GetUserAutoTradeLossCompPool2RecordsResultCode {
  Success = 0,
  Exception = 10,
}

/** `/game/cex/GetUserAutoTradeLossCompPool2Records` 响应体 */
export interface GetUserAutoTradeLossCompPool2RecordsResponse {
  resultCode: GetUserAutoTradeLossCompPool2RecordsResultCode | number;
  resultMsg: string;
  total: number;
  records: AutoTradeLossCompPool2RecordItem[];
}

// ===================== CEX 用户交易统计（自动/手动） =====================

/** `/game/cex/GetUserCexOrderTradeStats` 请求体（可选按平仓时间区间过滤） */
export interface GetUserCexOrderTradeStatsRequest {
  /** 可选，平仓时间下界（毫秒），命中条件：`closeTime >= closeTimeFromMs` */
  closeTimeFromMs?: number;
  /** 可选，平仓时间上界（毫秒，不含），命中条件：`closeTime < closeTimeToExclusiveMs` */
  closeTimeToExclusiveMs?: number;
}

/** 自动/手动/合计某一类下单方式的统计项 */
export interface CexOrderTradeModeStats {
  /** 已平仓笔数 */
  orderCount: number;
  /** 盈利笔数（`pnl > 0`） */
  winCount: number;
  /** 胜率百分比（0-100；无平仓单时为 0） */
  winRate: number;
  /** 盈亏合计（USDT） */
  totalPnl: number;
  /** 获得 TSKx 数量合计（仅 `CloseSplitLossUserTskx`） */
  totalTskx: number;
}

/** `/game/cex/GetUserCexOrderTradeStats` 响应体 */
export interface GetUserCexOrderTradeStatsResponse {
  /** 结果码 */
  resultCode: number;
  /** 结果文案 */
  resultMsg: string;
  /** 自动下单统计 */
  auto: CexOrderTradeModeStats;
  /** 手动下单统计 */
  manual: CexOrderTradeModeStats;
  /** 自动 + 手动合计 */
  total: CexOrderTradeModeStats;
}

// ===================== CEX 平台维度-按交易对日统计 =====================

/** `/game/cex/GetPlatformCexSymbolDayStats` 请求体 */
export interface GetPlatformCexSymbolDayStatsRequest {
  /** 可选，业务日（YYYYMMDD）；不传时由服务端按当前业务日处理 */
  statDay?: string;
}

/** 全平台单交易对在某业务日下的汇总 */
export interface PlatformCexSymbolDayStatItem {
  /** 交易对（如 BTCUSDT） */
  symbol: string;
  /** 全平台该交易对当日交易量之和 */
  todayTradingVolume: number;
  /** 全平台该交易对当日盈亏之和（USDT） */
  todayPnl: number;
  /** 全平台该交易对当日已平仓笔数之和 */
  orderCount: number;
}

/** `/game/cex/GetPlatformCexSymbolDayStats` 响应体 */
export interface GetPlatformCexSymbolDayStatsResponse {
  /** 结果码 */
  resultCode: number;
  /** 结果文案 */
  resultMsg: string;
  /** 实际查询的业务日（YYYYMMDD） */
  statDay: string;
  /** 各交易对统计项 */
  items: PlatformCexSymbolDayStatItem[];
}

// ===================== CEX 自动下单开关 =====================

/** `/game/cex/GetUserSetting` 请求体（空对象） */
export interface GetCexAutoTradeUserSettingRequest {}

/** GetUserSetting `noticeCode`：0-正常 1-资费不足（单笔算力费+手续费不足，不含本金） */
export enum CexAutoTradeNoticeCode {
  OK = 0,
  InsufficientFunds = 1,
}

/** `/game/cex/GetUserSetting` 响应体 */
export interface GetCexAutoTradeUserSettingResponse {
  /** 是否开启自动下单 */
  cexAutoTradeSwitch: boolean;
  /** 今日已自动开仓笔数（UTC0 自然日内） */
  todayOrderCount: number;
  /** 今日下单上限（平台配置，池 1 不足时 Cron 可能折半） */
  todayOrderLimit: number;
  /** 当前正在跑的自动订单数 */
  runningOrderCount: number;
  /** 单笔保证金 */
  autoPositionAmount: number;
  /** 杠杆倍数 */
  leverage: number;
  /** 单笔交易量 */
  vol: number;
  /** 0-正常 1-资费不足 */
  noticeCode: CexAutoTradeNoticeCode | number;
  /** 单笔预估算力费（USDT） */
  estimatedSignalFeeUsdt: number;
  /** 单笔预估手续费（USDT） */
  estimatedTradeFeeUsdt: number;
  /** 是否已激活 Fort Agent */
  hasActiveFortAgent: boolean;
}

/** `/game/cex/SetCexAutoTradeSwitch` resultCode */
export enum SetCexAutoTradeSwitchResultCode {
  /** 成功 */
  Success = 0,
  /** 异常 */
  Exception = 10,
}

/** `/game/cex/SetCexAutoTradeSwitch` 请求体 */
export interface SetCexAutoTradeSwitchRequest {
  /** true=开启，false=关闭 */
  enabled: boolean;
}

/** `/game/cex/SetCexAutoTradeSwitch` 响应体 */
export interface SetCexAutoTradeSwitchResponse {
  resultCode: SetCexAutoTradeSwitchResultCode | number;
  resultMsg: string;
}

// ===================== 币安现货行情（Redis，game 进程每 30s 拉 /api/v3/ticker/24hr） =====================

/** 与后端 `BinanceSpotQuoteItem` 对齐 */
export interface BinanceSpotQuoteItem {
  /** ETHUSDT / BTCUSDT */
  pair: string;
  /** 最新成交价（USDT） */
  lastPrice: string;
  /** 24h 涨跌幅（%） */
  priceChangePercent24h: string;
  /** 服务端写入 Redis 的时间（Unix 秒） */
  updatedAt: number;
}

/** 与后端 `GetBinanceSpotEthBtcQuoteResponse` 对齐 */
export interface GetBinanceSpotEthBtcQuoteResponse {
  items: BinanceSpotQuoteItem[];
}

// ===================== CEX 费用记录 =====================

/** 费用记录列表请求（/game/cex/GetCexFeeRecordList） */
export interface GetCexFeeRecordListRequest {
  /** 页码，从 1 起 */
  page?: number;
  /** 每页条数 */
  pageSize?: number;
}

/** 费用明细单币种 leg */
export interface CexFeeCoinLeg {
  /** 币种：FUSD / TSK / USDT */
  coinSymbol: string;
  /** 代币数量 */
  amount: number;
  /** 折合 USDT */
  valueUsdt: number;
}

/** 费用明细（可多 leg 分行展示） */
export interface CexFeeBreakdown {
  /** 各币种 leg；可为 null，前端按 `legs ?? []` 处理 */
  legs: CexFeeCoinLeg[] | null;
  /** 折合 USDT 合计 */
  totalUsdt: number;
}

/** 费用记录 orderStatus：1=已下单 2=仅获取信号 3=下单失败 */
export enum CexFeeRecordOrderStatus {
  Traded = 1,
  StrategyOnly = 2,
  OrderFailed = 3,
}

/** 单条 AI 策略交易费用记录卡片（`GetCexFeeRecordListResponse.items[]`） */
export interface CexFeeRecordCard {
  /** 扣费记录 ID */
  chargeRecordId: string;
  /** 策略 ID */
  strategyId: string;
  /** 创建时间（毫秒时间戳） */
  createTime: number;
  /** 是否自动下单 */
  autoOrder: boolean;
  /** 开仓：币对，如 BTCUSDT */
  symbol: string;
  /** 开仓：方向 buy / sell（亦可能为 hold-buy / hold-sell） */
  action: string;
  /** 开仓：杠杆倍数 */
  leverage: number;
  /** 开仓：订单状态 1=已下单 2=仅获取信号 3=下单失败 */
  orderStatus: CexFeeRecordOrderStatus | number;
  /** 开仓：盈亏（未平仓可为 0） */
  pnl: number;
  /** 预付算力费：取信号前预扣 */
  prepaySignalFee: CexFeeBreakdown;
  /** 平台收取：手续费+算力费+资金费（已成交/已结算时展示；下单失败为空） */
  platformFees: CexFeeBreakdown;
  /** 补扣：下单前第二次预扣（算力补差+交易费，不含本金）；仅下单成功使用 */
  supplementFee: CexFeeBreakdown;
  /** 下单失败全额退回（无 platformFees 时展示；自动下单失败退回的算力费） */
  fullRefund: CexFeeBreakdown;
  /** 算力费等多收退还（结算后超收退回） */
  computeFeeRefund: CexFeeBreakdown;
}

/** 费用记录列表响应（/game/cex/GetCexFeeRecordList） */
export interface GetCexFeeRecordListResponse {
  resultCode: number;
  resultMsg: string;
  /** 符合条件的总条数 */
  total: number;
  items: CexFeeRecordCard[];
}
